import { useMemo } from 'react'
import { string, object, number } from 'prop-types'
import { Link } from 'gatsby'
import { css } from '@emotion/react'
import {
  DesignToken,
  SpacingToken,
} from '@livechat/design-system-react-components'

import { sortByPopularity } from '@/utils/products'
import CardBase from '@/components/ProductList/Card/Base'
import Icon from '@/components/ProductList/Card/Icon'

const containerCss = css`
  display: flex;
  flex-direction: column;
`

const topPartCss = css`
  display: flex;
  margin-bottom: 10px;
`

const infoCss = css`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const titleCss = (theme) => css`
  display: block;
  width: 100%;
  margin: var(${SpacingToken.Spacing1}) var(${SpacingToken.Spacing4})
    var(${SpacingToken.Spacing1}) 0;
  font-size: var(${SpacingToken.Spacing5});
  line-height: var(${SpacingToken.Spacing6});
  letter-spacing: 0.005em;
  color: ${theme.colors.primary};
  font-weight: ${theme.font.bold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease-out;
`

const subtitleCss = (theme) => css`
  margin: 0 0 var(${SpacingToken.Spacing2}); 0;
  color: ${theme.colors.primary};
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: var(${SpacingToken.Spacing5});
  height: var(${SpacingToken.Spacing10});
  font-size: var(${SpacingToken.Spacing4});
  word-break: break-word;
`

const linkCss = css`
  width: 100%;
  padding: var(${SpacingToken.Spacing4});
`

const productsCss = css`
  padding-bottom: var(${SpacingToken.Spacing4});
  height: var(${SpacingToken.Spacing10});
  font-size: 14px;
  color: var(${DesignToken.DecorGray600});
  overflow: hidden;
  display: flex;
  align-items: center;

  > .gatsby-image-wrapper, > div {
    margin: var(${SpacingToken.Spacing1});
    padding: var(${SpacingToken.Spacing0}); !important;
    min-width: var(${SpacingToken.Spacing6});
    width: var(${SpacingToken.Spacing6});
    height: var(${SpacingToken.Spacing6});

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`

const textCss = css`
  padding-right: var(${SpacingToken.Spacing1});
`

const pickTopInstalledProducts = (products, count) => {
  products.sort(sortByPopularity)
  return products.slice(0, count)
}

const DeveloperCard = ({ dev, className, productsNumber, innerRef }) => {
  const { slug, bio, company, apps, services } = dev
  const linkToDev = `/developers/${slug}/`

  const topDevelopedProducts = useMemo(() => {
    const products = [...apps, ...services]
    return pickTopInstalledProducts(products, productsNumber)
  }, [apps, services, productsNumber])

  return (
    <CardBase withHover className={className}>
      <Link to={linkToDev} data-test="developerCard" css={linkCss}>
        <div css={containerCss} ref={innerRef}>
          <div css={topPartCss}>
            <div css={infoCss}>
              <p css={titleCss} className="devName">
                {company}
              </p>
              <div css={subtitleCss}>{bio}</div>
              <div css={productsCss}>
                <span css={textCss}>Developed</span>
                {topDevelopedProducts.map(({ id, icons, logo, name }) => (
                  <Icon key={id} icons={icons} logo={logo} alt={name} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </Link>
    </CardBase>
  )
}

DeveloperCard.propTypes = {
  dev: object,
  productsNumber: number,
  className: string,
  innerRef: object,
}
export default DeveloperCard
